<div class="right-margin">
    <button class="close-icon" (click)="closeDialog()"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="body form">
    @if (isForm) {
    <div class="max-height">
        @if (rewriteEstimationMode != null && rewriteEstimationMode) {
        <h2>Confirm Your Usage</h2>
        }
        @if (!rewriteEstimationMode && isAIBased) {
        <h2>Update your Consumption History</h2>
        }
        @if (!rewriteEstimationMode && !isAIBased) {
        <h2>Customize Your Savings</h2>
        }
        <kilowant-account-consumption [(account)]="account"
                                      [callUpdate]="callUpdate"
                                      [callCancel]="callCancel"
                                      [isAIBased]="isAIBased"
                                      [activated]="true"
                                      (setEstimated)="onSetEstimated()"
                                      (cancelled)="editCancel()"
                                      (finished)="updateAccountConsumptionFinish()"></kilowant-account-consumption>
        <div class="block-buttons full-width small mt-20">
            <button type="button" (click)="editCancel()">Skip</button>
            <button type="button" (click)="updateAccountConsumption()">
                Update
            </button>
        </div>
    </div>
    }
    @if (!isForm) {
    <div class="max-height">
        <h2>The kilowant Difference</h2>
        <p>
            <b>1. Only Savings.</b>
            kilowant displays only price plan offers which we forecast will save you money compared to your future market alternatives (ex. Utility or Community Energy Price). If we can't save you money across a future term, then the price plan offer does not appear.
        </p>
        <p>
            <b>2. Custom Savings.</b> kilowant calculates savings by weighting all pricing to
            <a (click)="gotoAccountConsumption();" class="link">your monthly usage profile</a> because total savings is driven by how much and when you use your energy. If you don't input your usage data, then we use your rate class average usage profile provided by the utility.
        </p>
        <p><b>3. ai Predictive Savings.</b> kilowant ai predicts if future savings is available beyond the term of your current utility and/or community energy rate filing which is typically 3-6 months. If we can't find you savings beyond your current price plan term, your account will return to your alternative Utility Supply Service.</p>
        <p></p>
        <p>* All price plan offers include a subscription to kilowant's Nonstop Shop ai technology, which automates the shopping for future savings opportunities beyond the term of your selected price plan...so you don't have to worry about term renewals at unauthorized prices.</p>
    </div>
    }
</div>